import React, { useState } from "react";
import api from '../../api/axiosInstance';
import UserLayout from "../../components/user/UserLayout";
import { Card, Form, Button, Alert, Spinner, InputGroup } from "react-bootstrap";
import { FaTint, FaFlask, FaRulerCombined, FaCheckCircle } from "react-icons/fa";

const AlcoholCalculator = () => {
  const [form, setForm] = useState({
    desiredConcentration: "",
    desiredTotalVolume: "",
    stockConcentration: "",
  });

  const [result, setResult] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const calculate = async (e) => {
    e.preventDefault();
    setError("");
    setResult(null);
    setLoading(true);

    try {
      const token = localStorage.getItem("token");

      const res = await api.post(
        "/alcohol/calculate",
        form,
        { headers: { Authorization: `Bearer ${token}` } }
      );

      setResult(res.data.result);
    } catch (err) {
      setError(err.response?.data?.message || "Hesaplama yapılamadı");
    } finally {
      setLoading(false);
    }
  };

  return (
    <UserLayout>
      {/* HEADER BÖLÜMÜ */}
      <div
        className="p-4 rounded-4 mb-4 shadow-sm text-white"
        style={{
          background: "linear-gradient(135deg, #2D8A7A 0%, #45b09e 100%)",
        }}
      >
        <h2 className="fw-bold mb-1">Alkol Derecesi Hesaplama</h2>
        <p className="mb-0" style={{ opacity: 0.9 }}>
          İstenilen dereceye ve hacme göre gereken alkol ve su miktarını hesaplayın.
        </p>
      </div>

      {/* ANA KART */}
      <Card
        className="p-4 shadow-lg rounded-4"
        style={{
          maxWidth: "650px",
          margin: "0 auto",
          background: "rgba(255,255,255,0.6)",
          backdropFilter: "blur(12px)",
          border: "1px solid rgba(255,255,255,0.4)",
        }}
      >
        <Form onSubmit={calculate}>
          {/* 🔢 INPUT - 1 */}
          <Form.Group className="mb-3">
            <Form.Label className="fw-semibold">İstenen Alkol Derecesi (%)</Form.Label>
            <InputGroup>
              <InputGroup.Text>
                <FaTint />
              </InputGroup.Text>
              <Form.Control
                type="number"
                name="desiredConcentration"
                value={form.desiredConcentration}
                onChange={handleChange}
                placeholder="Örn: 70"
                required
              />
            </InputGroup>
          </Form.Group>

          {/* 🔢 INPUT - 2 */}
          <Form.Group className="mb-3">
            <Form.Label className="fw-semibold">İstenen Hacim (mL)</Form.Label>
            <InputGroup>
              <InputGroup.Text>
              <FaRulerCombined />
              </InputGroup.Text>
              <Form.Control
                type="number"
                name="desiredTotalVolume"
                value={form.desiredTotalVolume}
                onChange={handleChange}
                placeholder="Örn: 100"
                required
              />
            </InputGroup>
          </Form.Group>

          {/* 🔢 INPUT - 3 */}
          <Form.Group className="mb-3">
            <Form.Label className="fw-semibold">Mevcut Alkol Derecesi (%)</Form.Label>
            <InputGroup>
              <InputGroup.Text>
                <FaFlask />
              </InputGroup.Text>
              <Form.Control
                type="number"
                name="stockConcentration"
                value={form.stockConcentration}
                onChange={handleChange}
                placeholder="Örn: 96"
                required
              />
            </InputGroup>
          </Form.Group>

          {/* ❌ HATA */}
          {error && <Alert variant="danger">{error}</Alert>}

          {/* 📌 BUTON */}
          <Button
            type="submit"
            size="lg"
            className="w-100 fw-bold mt-2"
            style={{
              backgroundColor: "#2D8A7A",
              borderColor: "#2D8A7A",
              borderRadius: "12px",
            }}
            disabled={loading}
          >
            {loading ? <Spinner size="sm" animation="border" /> : "Hesapla"}
          </Button>
        </Form>

        {/* ✔ SONUÇ KARTI */}
        {result && (
          <Card
            className="p-4 mt-4 rounded-4 shadow-sm animate__animated animate__fadeInUp"
            style={{
              borderLeft: "6px solid #2D8A7A",
              background: "#f6fffb",
            }}
          >
            <h5 className="fw-bold d-flex align-items-center mb-3" style={{ color: "#2D8A7A" }}>
              <FaCheckCircle className="me-2" /> Hesaplama Sonuçları
            </h5>

            <p className="mb-1">
              <strong>Gerekli Alkol Miktarı:</strong> {result.alcoholVolume} mL
            </p>

            <p className="mb-1">
              <strong>Gerekli Su Miktarı:</strong> {result.waterVolume} mL
            </p>

            <p className="mb-0">
              <strong>Nihai Toplam Hacim:</strong> {result.finalVolume} mL
            </p>
          </Card>
        )}
      </Card>
    </UserLayout>
  );
};

export default AlcoholCalculator;